import {Quad, gsap} from "gsap";

export default class HomeHeroController {
    constructor() {
        this.root = document.querySelector(".c-home-hero");

        this.image1 = document.getElementsByClassName("js-hero-image1");

        this.image2 = document.getElementsByClassName("js-hero-image2");

        if (this.image1 &&
            this.image2 &&
            this.root) {
            this.init();
        }
    }

    init() {

        this.root.addEventListener("mousemove", evt => {
            let x = evt.clientX / innerWidth;
            let y = evt.clientY / innerHeight;

            let decimalX = evt.clientX / window.innerWidth - 0.5;
            let decimalY = evt.clientY / window.innerHeight - 0.5;

            this.root.style.setProperty("--mouse-x", x);
            this.root.style.setProperty("--mouse-y", y);

            gsap.to(this.image1, 1, {
                rotationY: 0 * decimalY,
                x: 10 * decimalX,
                rotationX: 0 * decimalX,
                y: 2 * decimalY,
                ease: Quad.easeOut,
                transformPerspective: 900,
                transformOrigin: "center"
            });

            gsap.to(this.image2, 0.7, {
                rotationY: 0 * decimalY,
                x: 30 * decimalX,
                rotationX: 0 * decimalX,
                y: 5 * decimalY,
                ease: Quad.easeOut,
                transformPerspective: 900,
                transformOrigin: "center"
            });
        });
    }
}
